import React from "react";
import zee from "../../assets/logo/1024-white-zee.png";
import {
  COMPANY,
  COMPANY_ADDRESS,
  COMPANY_CIC_ADDRESS,
  COMPANY_CIC_NAME,
  COMPANY_CIC_NUMBER,
  COMPANY_NUMBER,
} from "../../core/constants";

const Footer = () => {
  return (
    <footer className="text-gray-100 body-font bg-indigo-900">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap md:text-left text-center order-first text-base">
          <div className="lg:w-1/4 md:w-1/2 w-full px-4">
            <h2 className="title-font font-medium text-gray-200 tracking-widest text-lg mb-3">
              FINANCE
            </h2>
            <nav className="list-none mb-10">
              <li>
                <a
                  href="/charityshoploan"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Charity Shop Loan
                </a>
              </li>
              <li>
                <a
                  href="/loans"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Loans
                </a>
              </li>
              <li>
                <a
                  href="/grants"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Grants
                </a>
              </li>
              <li>
                <a
                  href="/apply"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Apply for a loan
                </a>
              </li>
              <li>
                <a
                  href="/apply"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Apply for a grant
                </a>
              </li>
              <li>
                <a
                  href="/benefits"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Benefits Calculator
                </a>
              </li>
            </nav>
          </div>
          <div className="lg:w-1/4 md:w-1/2 w-full px-4">
            <h2 className="title-font font-medium text-gray-200 tracking-widest text-lg mb-3">
              HELP &amp; SUPPORT
            </h2>
            <nav className="list-none mb-10">
              <li>
                <a
                  href="/contact"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Help
                </a>
              </li>
              <li>
                <a
                  href="https://kestrl.io"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Kestrl Money Management
                </a>
              </li>
              <li>
                <a
                  href="https://novamoney.com/"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Nova Money
                </a>
              </li>
            </nav>
          </div>
          <div className="lg:w-1/4 md:w-1/2 w-full px-4">
            <h2 className="title-font font-medium text-gray-200 tracking-widest text-lg mb-3">
              ABOUT
            </h2>
            <nav className="list-none mb-10">
              <li>
                <a
                  href="/about"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/how-it-works"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  How it works
                </a>
              </li>
              <li>
                <a
                  href="/investors"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Investors &amp; Lending
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-gray-100 hover:text-indigo-300 cursor-pointer"
                >
                  Contact
                </a>
              </li>
            </nav>
          </div>
        </div>
      </div>
      <div className="bg-gray-100">
        <div className="container px-5 py-6 mx-auto flex items-center sm:flex-row flex-col">
          <a
            href="/"
            className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
          >
            <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-purple-800 text-purple-800 flex-shrink-0">
              <img src={zee} className="w-8 h-8" alt="ZeroPA" />
            </div>
          </a>

          <p className="text-sm text-gray-700 sm:ml-6">
            &copy; 2025 {COMPANY}. All rights reserved.
            <br />
            <a href="/terms" className="text-purple-600 hover:cursor-pointer">
              See all our terms &amp; conditions
            </a>
            <br />
            <span className="text-gray-500 text-xs inline-block pt-4">
              <span className="underline">Loans are provided by:</span>
              <br />
              {COMPANY} (Company No. {COMPANY_NUMBER}) in England and Wales,
              registered office address: {COMPANY_ADDRESS}
              <br />
              <br />
              <span className="underline">Grants are provided by:</span>
              <br />
              {COMPANY_CIC_NAME} (Company No. {COMPANY_CIC_NUMBER}), registered
              office address: {COMPANY_CIC_ADDRESS}.
              <br />
              <br />
              <span className="underline">Region:</span> United Kingdom
            </span>
          </p>

          <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
            <a
              href="https://facebook.com/zeropamadadcic"
              rel="noopener noreferrer"
              target="_blank"
              className="text-gray-500"
            >
              <svg
                fill="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
              </svg>
            </a>

            <a
              href="https://instagram.com/zeropa_madad"
              rel="noopener noreferrer"
              target="_blank"
              className="ml-3 text-gray-500"
            >
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
              </svg>
            </a>
            <a
              href="https://linkedin.com/company/zeropa/"
              rel="noopener noreferrer"
              target="_blank"
              className="ml-3 text-gray-500"
            >
              <svg
                fill="currentColor"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0"
                className="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="none"
                  d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                ></path>
                <circle cx="4" cy="4" r="2" stroke="none"></circle>
              </svg>
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
